import { makeObservable, override } from 'mobx';
import { Distances } from 'modules/racersTable/stores';

import { Distance as DistanceModel } from 'models';

class DistancesStore extends Distances {
  static filters: FiltersType = {
    limit: 9999,
    with: 'classes;waves;checkpoints;registration_fields;goal;squads',
    searchJoin: 'AND',
    sortBy: 'asc',
    orderBy: 'index',
    has: 'results',
  };

  constructor() {
    super();

    makeObservable(this);
  }

  @override
  get filteredModelValues(): DistanceModel[] {
    return this.modelValues.filter((distance) => distance.value.show_results);
  }

  @override
  get filteredValues(): DistanceType[] {
    return this.values.filter((distance) => distance.show_results);
  }
}

export { DistancesStore, DistancesStore as Distances };
